import React from 'react';
import { useLoaderData } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { useGetPersonasQuery } from '../../features/rapidstor/rapidstorApiSlice';

import classes from './StorageSizeSelector.module.scss';

import { ReactComponent as ChevronRight } from '../../assets/icon-right-chevron.svg';
import LargeUnitImage from '../../assets/large-unit.png';
import MediumUnitImage from '../../assets/medium-unit.png';
import SmallUnitImage from '../../assets/small-unit.png';
import VehicleImage from '../../assets/vehicle.png';

export interface StorageSizeType {
    name: string;
    icon: string;
    label: string;
    info: string;
    size: number;
}

function SizeCard(type: StorageSizeType, index: number) {
    return (
        <div
            className={`${classes.storage_size}`}
            key={index}
            data-storage-size={type.name}
        >
            <img
                src={type.icon}
                className={`${classes.icon} ${
                    type.name === 'Parking' && classes.vehicleImage
                }`}
            />
            <div className={`${classes.content}`}>
                <span>{type.name}</span>
                <span>{type.label}</span>
            </div>
            <ChevronRight className={`${classes.chevron}`} />
        </div>
    );
}

interface Props {
    setQuestionnaireSize: (size: number) => void;
    setQuestionnaireType: (type: string) => void;
}

function StorageSizeSelector({ setQuestionnaireSize, setQuestionnaireType }: Props) {
    const location = useLoaderData() as Location;
    const { data: personas } = useGetPersonasQuery(location.locationCode);

    const types: StorageSizeType[] = [
        {
            name: 'Small Unit',
            icon: SmallUnitImage,
            label: '1 Bedroom Apartment',
            info: 'This unit is perfect for a 2 to 3 bedroom apartment, account for small outdoor table setting or furniture',
            size: 0,
        },
        {
            name: 'Medium Unit',
            icon: MediumUnitImage,
            label: '2-3 Bedroom apartment',
            info: 'This unit is perfect for a 2 to 3 bedroom apartment, account for small outdoor table setting or furniture',
            size: location.rapidstor.smallMediumSizes,
        },
        {
            name: 'Large Unit',
            icon: LargeUnitImage,
            label: '4 Bedroom House',
            info: 'This unit is perfect for a 3-5 bedroom house, account for small outdoor table setting or furniture',
            size: location.rapidstor.mediumLargeSizes,
        },
    ];

    return (
        <div className={`${classes.container}`}>
            {types.map((type, index) => (
                <div key={type.name} onClick={() => setQuestionnaireSize(type.size)}>
                    <SizeCard
                        name={type.name}
                        icon={type.icon}
                        label={type.label}
                        info={type.info}
                        size={type.size}
                        key={index}
                    />
                </div>
            ))}
            {personas?.some((persona) => persona.name === 'Vehicle') && (
                <div
                    key={`custom_card`}
                    onClick={() => {
                        setQuestionnaireSize(0);
                        setQuestionnaireType('vehicle');
                    }}
                >
                    <SizeCard
                        name={'Parking'}
                        icon={VehicleImage}
                        label={'Car, Boat, Caravan or Trailer'}
                        info={'Car, Boat, Caravan or Trailer'}
                        size={0}
                        key={'custom_card_1'}
                    />
                </div>
            )}
        </div>
    );
}

export default StorageSizeSelector;
